export default __webpack_public_path__ + "img/15885a05045ce01fc952e7d8e886c99e.svg";